import { ServiceTokens } from "$src/domain/ServiceTokens";
import { DocumentIdentifier } from "$src/domain/projects/documents/DocumentIdentifier";
import { DocumentMeta } from "$src/domain/projects/documents/DocumentMeta";
import type { IDocumentRepository } from "$src/domain/projects/documents/IDocumentRepository";
import { inject, injectable } from "tsyringe";

@injectable()
export class UpdateDocument {
    
    constructor(@inject(ServiceTokens.DocumentRepository) private documentRepository: IDocumentRepository) {}

    async execute(groupStoreId: number, projectId: number, documentId: string, meta: DocumentMeta): Promise<DocumentIdentifier> {

        var identifier = await this.documentRepository.updateDocument(groupStoreId, projectId, documentId, meta);

        return identifier;
    }
}

export const UpdateDocumentToken = Symbol('UpdateDocumentToken');